export default __webpack_public_path__ + "static/media/arw-04110.8db2fcbc.jpg";